import type { Theme, ThemeId } from './types';
import { defaultTheme } from './default';
import { darkTheme } from './dark';
import { glassTheme } from './glass';
import { minimalTheme } from './minimal';
import { gradientTheme } from './gradient';
import { corporateTheme } from './corporate';

export const themes: Theme[] = [
  defaultTheme,
  darkTheme,
  glassTheme,
  minimalTheme,
  gradientTheme,
  corporateTheme,
];

export const themeMap: Record<ThemeId, Theme> = {
  default: defaultTheme,
  dark: darkTheme,
  glass: glassTheme,
  minimal: minimalTheme,
  gradient: gradientTheme,
  corporate: corporateTheme,
};

export const getThemeById = (id: string): Theme => {
  return themeMap[id as ThemeId] || glassTheme;
};

export { defaultTheme, darkTheme, glassTheme, minimalTheme, gradientTheme, corporateTheme };
export type { Theme, ThemeId, ThemeColors, ThemeEffects, ThemePreview } from './types';
